export default __webpack_public_path__ + "static/media/icon_endtype_SquareOpenEnds.afec6cf2.png";